<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import AuthUserStore from '@/Stores/AuthUserStore.js';

	let profileOpen = false;

	const getInitials = () => {
		return (
			(($AuthUserStore.first_name && $AuthUserStore.first_name.charAt(0)) ?? '') +
			(($AuthUserStore.last_name && $AuthUserStore.last_name.charAt(0)) ?? '')
		).toUpperCase();
	};

	$: initials = $AuthUserStore && getInitials();

	const close = () => (profileOpen = false);

	const toggle = () => (profileOpen = !profileOpen);

	const handleKeydown = (e) => {
		if (!profileOpen) {
			return;
		}
		if (e.key === 'Escape') {
			close();
		}
	};

	const handleClickAway = (e) => {
		if (profileOpen && !e.target.closest('#user_menu') && !e.target.closest('#user_menu_button')) {
			close();
		}
	};

	function logout() {
		AuthUserStore.logout().then(() => {
			navigate('/');
		});
	}
</script>

<svelte:window on:keydown={handleKeydown} on:mousedown={handleClickAway} />

<div class="relative">
	<div>
		<button
			on:click={toggle}
			class="flex text-sm transition duration-150 ease-in-out border-2 border-transparent rounded-full focus:outline-none focus:border-primary"
			id="user_menu_button"
			aria-label="User menu"
			aria-haspopup="true"
		>
			<span class="flex items-center justify-center rounded-full border border-secondary w-9 h-9 bg-black text-primary">
				<span class="font-semibold">{initials}</span>
			</span>
		</button>
	</div>
	{#if profileOpen}
		<div id="user_menu" class="absolute right-0 z-40 w-48 mt-2 origin-top-right rounded-md shadow-lg">
			<div
				class="py-1 bg-white rounded-md shadow-xs"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="user-menu"
			>
				<a
					href="/profile"
					on:click={close}
					class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-300 focus:outline-none focus:bg-gray-100"
				>
					My Profile
				</a>
				<a
					href="/settings"
					on:click={close}
					class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-300 focus:outline-none focus:bg-gray-100"
				>
					Settings
				</a>
				<button
					on:click={logout}
					class="block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 transition duration-150 ease-in-out hover:bg-gray-300 focus:outline-none focus:bg-gray-100"
				>
					Sign out
				</button>
			</div>
		</div>
	{/if}
</div>
